// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useParams } from '@tanstack/react-router';

// material ui
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

// feature-components
import ServiceActivationSwitch from '@/features/service-manager/components/ServiceActivationSwitch';

export const Route = createFileRoute(
  '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer-analytics',
)({
  component: RouteComponent,
  staticData: {
    crumb: 'service-manager:services.energyxplorer-analytics.title',
  },
});

function RouteComponent() {
  const { managedAccountId } = useParams({
    from: '/$accountId/_admin/service-manager/$managedAccountId/energyxplorer-analytics',
  });

  const { t } = useTranslation('service-manager');

  return (
    <Stack spacing={2}>
      <Card>
        <CardHeader
          title={t('services.energyxplorer-analytics.title')}
          action={
            <ServiceActivationSwitch
              managedAccountId={managedAccountId}
              servicePath="energyxplorer-analytics"
              ariaLabel={t('services.energyxplorer-analytics.title')}
            />
          }
          slotProps={{
            title: { variant: 'h6', fontWeight: 600 },
          }}
        />
        <Divider />
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {t('services.energyxplorer-analytics.description')}
          </Typography>
        </CardContent>
      </Card>
    </Stack>
  );
}
